import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class Dropoff extends BaseDataModel {
	name!: string;
	latitude!: number;
	longitude!: number;
}
